import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnInit,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { buildProviders, KalListComponent, KalSelectionModel } from '@kalidea/kaligraphi';
import { CustomFormControlAccess } from 'src/app/_core/tools/custom-form-control-access';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import {
    DocumentBankListDatasource
} from 'src/app/_shared/dialogs/document-bank-dialog/document-bank-list/document-bank-list-datasource';
import { GraphqlService } from 'src/app/_core/services/graphql.service';
import { FichierCompletModel, GedCriteresFiltrageGedModelInput } from 'src/graphql/generated-types';
import { arrayEmpty } from 'src/app/utils/array.utils';
import { tap } from 'rxjs/operators';
import {
    PartialDocumentBankFilters
} from 'src/app/_shared/dialogs/document-bank-dialog/document-bank-list-dialog/document-bank-list-dialog.component';

@Component({
    selector: 'app-document-bank-list',
    templateUrl: './document-bank-list.component.html',
    styleUrls: ['./document-bank-list.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: buildProviders(DocumentBankListComponent),
    standalone: false
})
export class DocumentBankListComponent extends CustomFormControlAccess implements OnInit {

    isOpenedFilters = false;

    form: UntypedFormGroup;

    documentsListDatasource: DocumentBankListDatasource;

    loading = false;

    @ViewChild(KalListComponent) list: KalListComponent<FichierCompletModel>;

    @Input() disabledFilters: PartialDocumentBankFilters = null;

    constructor(private readonly cdr: ChangeDetectorRef,
                private readonly graphqlService: GraphqlService,
                private readonly fb: UntypedFormBuilder) {
        super();
        this.documentsListDatasource = new DocumentBankListDatasource(this.graphqlService);
    }

    private static normalizeFilters(formValues: any): GedCriteresFiltrageGedModelInput {
        return {
            CodeEditCateg: formValues.filters.categoryCode,
            LibelleTypeFichiers: formValues.filters.type,
            StatutId: formValues.filters.statusId,
            MotCles: formValues.searchbar ?? null,
            IsDateDepassee: formValues.filters.hasExpired,
            IsNonLie: formValues.filters.isUnlinked,
        };
    }

    writeValue(value: FichierCompletModel) {
        this.list?.selection?.select(value);
        super.writeValue(value);
    }

    selectDocument($event: KalSelectionModel<FichierCompletModel>): void {
        if (arrayEmpty($event.added)) {
            return;
        }
        this.notifyUpdate($event.added[0]);
    }

    toggleFilters(): void {
        this.isOpenedFilters = !this.isOpenedFilters;
    }

    ngOnInit(): void {
        this.form = this.fb.group({
            searchbar: [],
            filters: [{
                categoryCode: null,
                type: null,
                statusId: null,
                hasExpired: false,
                isUnlinked: false,
            }]
        });
        this.documentsListDatasource.setFilters(DocumentBankListComponent.normalizeFilters(this.form.value));

        // Écouteur des filtres
        this.watch$ = this.form.valueChanges.pipe(
            tap(formValues => {
                this.documentsListDatasource.setFilters(DocumentBankListComponent.normalizeFilters(formValues));
                this.documentsListDatasource.reset(); // getList et le loader sont automatiques
            })
        );

        // écoute loader
        this.watch$ = this.documentsListDatasource.loading$.pipe(
            tap(loading => {
                this.loading = loading;
                this.cdr.markForCheck();
            })
        );
    }

}
